import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { DataService, BaseDataService } from '../core/services';
import { API_URL } from '../constants';

import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { IPagedResults } from '../core/interfaces';

@Injectable()
export class AuthenticationService extends BaseDataService {
    constructor(protected dataService: DataService) {
        super(dataService, API_URL);
    }

    private hasData = new BehaviorSubject({ Id: 0, Name: "", Description: "", IsModule: false, IsUser: false });
    public getRoeleObservable = this.hasData.asObservable();

    public auth(data) {
        let url = `Authentication/Login`;
        return super.save<any>(url, data);
    }

    public logoff(data) {
        let url = `Authentication/Logoff?userId=${data.userId}`;
        return super.save<any>(url, data);
    }

    public forgotPassword(data) {
        let url = `Authentication/ForgotPassword`;
        return super.save<any>(url, data);
    }

    public getRole(userId: number, moduleId: number, siteId: number): Observable<any> {
        let url = `Authentication/GetRole?userId=${userId}&moduleId=${moduleId}&siteId=${siteId}`;
        var dd = super.getAll<any>(url);

        dd.subscribe((dg) => {

            this.hasData.next(dg.Data);
        });

        return dd;
    }
    public getRoleByModule(userId: number, moduleId: number): Observable<any> {
        let url = `Authentication/GetRoleByModule?userId=${userId}&moduleId=${moduleId}`;
        var dd = super.getAll<any>(url);

        dd.subscribe((dg) => {

            this.hasData.next(dg.Data);
        });

        return dd;
    }
    public GetUsers(moduleId: number, siteId: number): Observable<any> {
        let url = `Authentication/GetUsers?moduleId=${moduleId}&siteId=${siteId}`;
        return super.getAll<any>(url);
    }

    public decodeToken(data: any) {
        let url = `Authentication/DecodeToken`

        return super.save<any>(url, data)
    }

    public ChangePassword(data: any): Observable<any> {
        let url = `User/ChangePassword`
        return super.put<any>(url, data)
    }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts